<template>
  <div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <vx-card>
            <div class="row">
              <div class="col-md-12 text-right">
                <vs-button to="/machines/add">{{ $t('addMachine') }}</vs-button>
              </div>

              <div class="col-md-12 mt-4">
                <vs-input
                  size="small"
                  style="float:right;height:15px"
                  @input="isTyping = true"
                  v-model="SearchText"
                  :label-placeholder="$t('search')"
                />
              </div>
              <vs-table
                max-items="20"
                stripe
                :data="$store.state.machines"
                class="w-full ml-3 mr-3"
                maxHeight="1000px"
              >
                <template slot="header">
                  <h3>{{ $t('machines') }}</h3>
                </template>
                <template slot="thead">
                  <vs-th class="colors width">{{$t("controller")}}</vs-th>
       
                  <vs-th class="colors" sort-key="machineName">{{$t("machineName")}}</vs-th>
                  <vs-th class="colors" sort-key="teamViewerId">{{$t("teamViewerId")}}</vs-th>
                  <vs-th class="colors" sort-key="teamViewerPassword">{{$t("teamViewerPassword")}}</vs-th>
                  <vs-th class="colors" sort-key="anyDeskId">{{$t("anydDeskId")}}</vs-th>
                  <vs-th class="colors" sort-key="anyDeskPassword">{{$t("anyDeskPassword")}}</vs-th>
                </template>
                <template slot-scope="{data}">
                  <vs-tr class="tr" :key="indextr" v-for="(item, indextr) in data">
                    <vs-td :data="item.id">
                      <ActionButton
                        :id="item.id"
                        :machineName="item.machineName"
                        :teamViewerId="item.teamViewerId"
                        :teamViewerPassword="item.teamViewerPassword"
                        :anyDeskId="item.anyDeskId"
                        :anyDeskPassword="item.anyDeskPassword"
                        @refresh="selectPage"
                      ></ActionButton>
                    </vs-td>
                    <vs-td :data="item.machineName">{{ item.machineName }}</vs-td>
                    <vs-td :data="item.teamViewerId">{{ item.teamViewerId }}</vs-td>
                    <vs-td :data="item.teamViewerPassword">{{ item.teamViewerPassword }}</vs-td>
                    <vs-td :data="item.anyDeskId">{{ item.anyDeskId }}</vs-td>
                    <vs-td :data="item.anyDeskPassword">{{ item.anyDeskPassword }}</vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="col-md-12 mt-5">
                <vs-pagination
                  v-show="$store.state.machines.length != 0"
                  :total="totalPage"
                  :max="9"
                  v-model="currentPage"
                  @change="selectPage"
                ></vs-pagination>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import ActionButton from "./Buttons/ActionsButton";
import http from "../../../http/http-helper";
import _ from "lodash";

export default {
  components: {
    ActionButton
  },
  data() {
    return {
      currentPage: 1,
      totalPage: 0,
      SearchText: "",
      isTyping: false,
      machines: []
    };
  },
  watch: {
    SearchText: _.debounce(function() {
      this.isTyping = false;
    }, 500),
    isTyping: function(value) {
      if (!value) {
        this.search(this.SearchText);
      }
    }
  },
  methods: {
    selectPage(id) {
      // Get Machines
      this.$vs.loading();
      if (id == "") id = 1;
      this.currentPage = id;
      this.$vs.loading();
      let path = "/machines/getlist";
      http.post(path, { RequestPage: id }).then(response => {
        this.currentPage = response.currentPage;
        this.totalPage = response.totalPage;
        this.machines = response.data;
        this.$store.state.machines = this.machines;
        this.$vs.loading.close();
      });
    },
    search() {
      this.$vs.loading();
      let path = "/machines/getlist";
      http
        .post(path, {
          RequestPage: 1,
          SearchText: this.SearchText
        })
        .then(response => {
          if (response.data.lenght == 0) {
            this.$vs.loading.close();
            return this.$vs.notify({
              title: this.$t("nomatch"),
              color: "warning"
            });
          }
          this.currentPage = response.currentPage;
          this.totalPage = response.totalPage;
          this.machines = response.data;
          this.$store.state.machines = this.machines;
          this.$vs.loading.close();
        });
    }
  },
  mounted() {},
  created() {}
};
</script>
<style scoped>
.colors {
  background-color: rgb(218, 216, 216) !important;
}

.width {
  width: 110px !important;
}
</style>